<header class="mt-2 bg-white rounded-t-2xl shadow-container px-4 py-3">

<div class="w-100 flex flex-row items-center justify-between gap-4 border-b pb-3 border-[#E8EAEF] bg-white">

  <div class="flex items-center gap-3 min-w-0">
    <!-- Botón para re-expandir el sidebar cuando está colapsado (desktop) -->
    <button class="course-layout__expand-btn shrink-0" type="button"
        [attr.aria-label]="'words.menu' | translate"
        (click)="expandSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m9 18 6-6-6-6"></path>
        </svg>
    </button>

    <!-- Hamburger (solo mobile): ocupa el lugar del expand-btn -->
    <button class="course-layout__hamburger shrink-0" type="button"
        [attr.aria-label]="'words.menu' | translate"
        (click)="toggleSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
    </button>

    <!-- ── Breadcrumb / Nombre del curso ── -->
    <nav class="hidden md:flex items-center gap-2 text-sm text-gray-500 min-w-0">

        <!-- Separador chevron reutilizable -->
        <ng-template #chevron>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 shrink-0 text-gray-400" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m9 18 6-6-6-6"></path>
            </svg>
        </ng-template>

        <!-- Prefijo Learning Path: Journey > (Template) > -->
        <ng-container *ngIf="isFromLearningPath">
            <span class="shrink-0 text-gray-500">{{ 'words.journey' | translate }}</span>
            <ng-container *ngTemplateOutlet="chevron"></ng-container>

            <ng-container *ngIf="course?.template?.title">
                <span class="shrink-0 text-gray-500">{{ course?.template?.title }}</span>
                <ng-container *ngTemplateOutlet="chevron"></ng-container>
            </ng-container>
        </ng-container>

        <!-- Jerarquía común: Curso > Sección activa > Contenido activo -->
        <span class="shrink-0"
            [ngClass]="(!activeSection && !activeSectionContent) ? 'text-gray-700 font-normal' : 'text-gray-500'">
            {{ course?.title || ('player.untitled-course' | translate) }}
        </span>

        <ng-container *ngIf="activeSection">
            <ng-container *ngTemplateOutlet="chevron"></ng-container>
            <span [class.shrink-0]="activeSectionContent" [class.truncate]="!activeSectionContent"
                [ngClass]="!activeSectionContent ? 'text-gray-700 font-normal' : 'text-gray-500'">
                {{ activeSection?.title }}
            </span>
        </ng-container>

        <ng-container *ngIf="activeSectionContent">
            <ng-container *ngTemplateOutlet="chevron"></ng-container>
            <span class="text-gray-700 font-normal truncate">
                {{ activeSectionContent?.title }}
            </span>
        </ng-container>

    </nav>
  </div>

    <!-- ── Acciones de la derecha ── -->
    <div class="flex items-center gap-2 shrink-0">

   
        <!-- Ver resultados (solo cuando progreso >= 100%) -->
        <!-- z-index inline (>#view, que es z-9999) para que el tooltip "MIS RESULTADOS" no se recorte abajo -->
        <a [routerLink]="['/course', course?.id, 'results']"
            style="z-index: 10000;"
            class="group relative w-8 h-8 rounded-[8px] border border-[#E8EAEF] flex items-center justify-center text-[#5F6877] hover:bg-[#F6F7F9] transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-clipboard-check w-3.5 h-3.5 text-gray-500 group-hover:text-secondary-500">
                <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                <path d="m9 14 2 2 4-4"></path>
            </svg>
            <span class="pointer-events-none absolute top-full right-0 mt-2 px-3 py-1 rounded-md text-xs font-medium text-white bg-[#22304C] whitespace-nowrap opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 z-50">
                {{ 'player.course.results' | translate }}
            </span>
        </a>

        <!-- Reset sesión (solo en modo preview) -->
        <button *ngIf="preview"
            (click)="resetCurrentSubscriptionSession()"
            [title]="'player.reset-session' | translate"
            class="w-8 h-8 rounded-[8px] border border-[#E8EAEF] flex items-center justify-center text-[#5F6877] hover:bg-[#F6F7F9] transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-500 hover:text-secondary-500 " viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"></polyline>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
        </button>

        <!-- Salir del player -->
        <button (click)="back()"
            [attr.aria-label]="'words.leave' | translate"
            class="group relative w-8 h-8 rounded-[8px] border border-[#E8EAEF] flex items-center justify-center text-[#5F6877] hover:bg-[#F6F7F9] transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-500 group-hover:text-secondary-500" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" x2="9" y1="12" y2="12"></line>
            </svg>
            <span class="pointer-events-none absolute top-full right-0 mt-2 px-3 py-1 rounded-md text-xs font-medium text-white bg-[#22304C] whitespace-nowrap opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 z-50">
                {{ 'words.leave-course' | translate }}
            </span>
        </button>

    </div>

</div>

</header>